"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSemiDetachedHouse = function IconSemiDetachedHouse(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 49 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m24.021 6.923 21 8.4v6.154l-2-.8v2.602l4.943 1.65a24 24 0 0 1-.166 2.053L41.02 24.72v-4.843l-16-6.4V43h-2V13.477l-16 6.4v4.843L.168 27.008Q.042 25.994 0 24.956l5.021-1.677v-2.602l-2 .8v-6.154zm19 11.6-18-7.2V9.477l18 7.2zm-38-1.847 18-7.2v1.847l-18 7.199zM3.021 29h17v2h-1v12H9.317q-.622-.48-1.21-1h9.914v-2h-11v-1h11v-2h-13v-1h13v-5h-13v7.716q-.524-.673-1-1.385V31h-1zm13 4v1h-11v-1zm27-2h1v-2h-17v2h1v12h10.625q.621-.48 1.21-1H29.021V31h13v2h-11v1h11v2h-13v1h13v2.83q.52-.592 1-1.217zm-3 8v1h-11v-1zm-21-20h-4v6h4zm-1 1v4h-2v-4zm11-1h4v6h-4zm3 5v-4h-2v4z",
    clipRule: "evenodd"
  })));
};

export { IconSemiDetachedHouse, IconSemiDetachedHouse as default };
